// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"51d08029","456":"7c38169c","547":"8aedc18d","818":"3224fd29"}[chunkId] + ".chunk.css";
};